import { render, staticRenderFns } from "./coursewareStatis.vue?vue&type=template&id=6efb92c5&scoped=true"
import script from "./coursewareStatis.vue?vue&type=script&lang=js"
export * from "./coursewareStatis.vue?vue&type=script&lang=js"
import style0 from "./coursewareStatis.vue?vue&type=style&index=0&id=6efb92c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb92c5",
  null
  
)

export default component.exports